<template>
  <v-app>
    <v-overlay :value="isLoading" absolute>
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-overlay>

    <NavBar v-if="!isLoading"
            :logoPrefeitura="logoPrefeitura"
            :habilitaLinkNotaAvulsa="habilitaLinkNotaAvulsa"
            :habilitadoAutenticacaoPessoaFisica="habilitadoAutenticacaoPessoaFisica"
            :habilitadoAutenticacaoPessoaJuridica="habilitadoAutenticacaoPessoaJuridica"
            :urlCadastroPessoaFisica="urlCadastroPessoaFisica"
            :urlCadastroPessoaJuridica="urlCadastroPessoaJuridica"
            :permiteRedefinicaoEmail="permiteRedefinicaoEmail"
            :botaoCardCadastro="botaoCardCadastro"
            :botaoCardEntrar="botaoCardEntrar"
            :habilitadoCardPrimeiroAcesso="habilitadoCardPrimeiroAcesso"
            :habilitadoCardCadastro="habilitadoCardCadastro"
    />
    <v-main v-if="!isLoading" class="white">
      <v-divider class="secondary pt-1"></v-divider>
      <router-view
          :bannerTopo="bannerTopo"
          :nomeSistema="nomeSistema"
          :textoBanner="textoBanner"
          :sobreSistema="sobreSistema"
          :linkCadastro="linkCadastro"
          :endereco="endereco"
          :telefone="telefone"
          :linkMovidesk="linkMovidesk"
          :perguntas="perguntas"
          :itemsLegislacao="itemsLegislacao"
          :textoExplicativoWebService="textoExplicativoWebService"
          :tipoConsultaAtividade="tipoConsultaAtividade"
          :urlAtividade="urlAtividade"
          :habilitaLinkNotaAvulsa="habilitaLinkNotaAvulsa"

          :permiteRedefinicaoEmail="permiteRedefinicaoEmail"

          :habilitadoCardEntrar="habilitadoCardEntrar"
          :tituloCardEntrar="tituloCardEntrar"
          :textoCardEntrar="textoCardEntrar"
          :botaoCardEntrar="botaoCardEntrar"

          :habilitadoCardPrimeiroAcesso="habilitadoCardPrimeiroAcesso"
          :tituloCardPrimeiroAcesso="tituloCardPrimeiroAcesso"
          :textoCardPrimeiroAcesso="textoCardPrimeiroAcesso"
          :botaoCardPrimeiroAcesso="botaoCardPrimeiroAcesso"

          :habilitadoCardCadastro="habilitadoCardCadastro"
          :tituloCardCadastro="tituloCardCadastro"
          :textoCardCadastro="textoCardCadastro"
          :botaoCardCadastro="botaoCardCadastro"

          :habilitadoCardPasso1="habilitadoCardPasso1"
          :tituloCardPasso1="tituloCardPasso1"
          :textoCardPasso1="textoCardPasso1"

          :habilitadoCardPasso2="habilitadoCardPasso2"
          :tituloCardPasso2="tituloCardPasso2"
          :textoCardPasso2="textoCardPasso2"

          :habilitadoCardPasso3="habilitadoCardPasso3"
          :tituloCardPasso3="tituloCardPasso3"
          :textoCardPasso3="textoCardPasso3"

          :habilitadoCardPasso4="habilitadoCardPasso4"
          :tituloCardPasso4="tituloCardPasso4"
          :textoCardPasso4="textoCardPasso4"

          :canaisAtendimento="canaisAtendimento"
          :habilitadoLinkFaleConosco="habilitadoLinkFaleConosco"

          :habilitadoAutenticacaoPessoaFisica="habilitadoAutenticacaoPessoaFisica"
          :habilitadoAutenticacaoPessoaJuridica="habilitadoAutenticacaoPessoaJuridica"

          :urlCadastroPessoaFisica="urlCadastroPessoaFisica"
          :urlCadastroPessoaJuridica="urlCadastroPessoaJuridica">
      </router-view>
    </v-main>
    <Footer v-if="!isLoading"
            :logoRodape="logoRodape" :sigla-empresa="siglaEmpresa" :nome-empresa="nomeEmpresa"/>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer";
import EventService from "./services/EventService";
import {BASE_URL} from "./global";

export default {
  name: "App",
  components: {
    NavBar,
    Footer,
  },
  data: () => ({
    isLoading: true,
    bannerTopo: null,
    nomeSistema: "",
    textoBanner: "",
    sobreSistema: "",
    logoPrefeitura: null,
    logoRodape: "",
    endereco: "",
    telefone: "",
    linkMovidesk: "",
    perguntas: [],
    itemsLegislacao: null,
    textoExplicativoWebService: "",
    siglaEmpresa: "",
    nomeEmpresa: "",
    tipoConsultaAtividade: "",
    urlAtividade: "",
    habilitaLinkNotaAvulsa: false,

    habilitadoAutenticacaoPessoaFisica: false,
    habilitadoAutenticacaoPessoaJuridica: false,

    urlCadastroPessoaFisica: "",
    urlCadastroPessoaJuridica: "",

    permiteRedefinicaoEmail: true,

    habilitadoCardEntrar: false,
    tituloCardEntrar: "",
    textoCardEntrar: "",
    botaoCardEntrar: "",

    habilitadoCardPrimeiroAcesso: false,
    tituloCardPrimeiroAcesso: "",
    textoCardPrimeiroAcesso: "",
    botaoCardPrimeiroAcesso: "",

    habilitadoCardCadastro: false,
    tituloCardCadastro: "",
    textoCardCadastro: "",
    botaoCardCadastro: "",

    habilitadoCardPasso1: false,
    tituloCardPasso1:"",
    textoCardPasso1:"",

    habilitadoCardPasso2: false,
    tituloCardPasso2:"",
    textoCardPasso2:"",

    habilitadoCardPasso3: false,
    tituloCardPasso3:"",
    textoCardPasso3:"",

    habilitadoCardPasso4: false,
    tituloCardPasso4:"",
    textoCardPasso4:"",

    canaisAtendimento: "",
    habilitadoLinkFaleConosco: true,
  }),
  created() {
    this.linkCadastro = `${BASE_URL}/controleacesso/paginas/usuario/listaUsuarioExterno.jsf?multiTenantId=8&mostraCampoMatricula=N&faces-redirect=true`;

    EventService.getConteudo().then((response) => {
      // cores
      this.$vuetify.theme.themes.light.primary = response.data.corPrimaria;
      this.$vuetify.theme.themes.light.secondary = response.data.corSecundaria;
      // hero
      this.bannerTopo = response.data.imagemBanner;
      this.nomeSistema = response.data.nomeSistema;
      this.textoBanner = response.data.textoBannerNotaFiscal;
      this.sobreSistema = response.data.textoExplicativoNotaFiscal;
      // footer e navbar
      this.logoPrefeitura = response.data.imagemPrefeitura;
      this.logoRodape = response.data.imagemRodape;
      // contato
      this.endereco = response.data.enderecoAtendimento;
      this.telefone = response.data.telefoneAtendimento;
      this.linkMovidesk = response.data.linkFormularioAtendimentoMovidesk;
      // perguntas
      this.perguntas = response.data.listaCategoriaPergunta;
      // legislacao
      this.itemsLegislacao = response.data.listaLegislacao;
      // lote
      this.textoExplicativoWebService = response.data.textoExplicativoWebService;
      // empresa
      this.siglaEmpresa = response.data.siglaEmpresa;
      this.nomeEmpresa = response.data.nomeEmpresa;

      this.tipoConsultaAtividade = response.data.tipoConsultaAtividade;
      this.urlAtividade = response.data.urlAtividade;

      this.habilitaLinkNotaAvulsa = response.data.habilitaLinkNotaAvulsa;

      this.permiteRedefinicaoEmail = response.data.permiteRedefinicaoEmail;

      this.habilitadoCardEntrar = response.data.habilitadoCardEntrarEletronica;
      this.tituloCardEntrar = response.data.tituloCardEntrarEletronica;
      this.textoCardEntrar = response.data.textoCardEntrarEletronica;
      this.botaoCardEntrar = response.data.botaoCardEntrarEletronica;

      this.habilitadoCardPrimeiroAcesso = response.data.habilitadoCardPrimeiroAcessoEletronica;
      this.tituloCardPrimeiroAcesso = response.data.tituloCardPrimeiroAcessoEletronica;
      this.textoCardPrimeiroAcesso = response.data.textoCardPrimeiroAcessoEletronica;
      this.botaoCardPrimeiroAcesso = response.data.botaoCardPrimeiroAcessoEletronica;

      this.habilitadoCardCadastro = response.data.habilitadoCardCadastroEletronica;
      this.tituloCardCadastro = response.data.tituloCardCadastroEletronica;
      this.textoCardCadastro = response.data.textoCardCadastroEletronica;
      this.botaoCardCadastro = response.data.botaoCardCadastroEletronica;

      this.habilitadoCardPasso1 = response.data.habilitadoCardPasso1Eletronica;
      this.tituloCardPasso1 = response.data.tituloCardPasso1Eletronica;
      this.textoCardPasso1 = response.data.textoCardPasso1Eletronica;

      this.habilitadoCardPasso2 = response.data.habilitadoCardPasso2Eletronica;
      this.tituloCardPasso2 = response.data.tituloCardPasso2Eletronica;
      this.textoCardPasso2 = response.data.textoCardPasso2Eletronica;

      this.habilitadoCardPasso3 = response.data.habilitadoCardPasso3Eletronica;
      this.tituloCardPasso3 = response.data.tituloCardPasso3Eletronica;
      this.textoCardPasso3 = response.data.textoCardPasso3Eletronica;

      this.habilitadoCardPasso4 = response.data.habilitadoCardPasso4Eletronica;
      this.tituloCardPasso4 = response.data.tituloCardPasso4Eletronica;
      this.textoCardPasso4 = response.data.textoCardPasso4Eletronica;

      this.canaisAtendimento = response.data.canaisAtendimento;
      this.habilitadoLinkFaleConosco=response.data.habilitadoLinkFaleConosco;

      this.habilitadoAutenticacaoPessoaFisica = response.data.habilitadoAutenticacaoPessoaFisica;
      this.habilitadoAutenticacaoPessoaJuridica = response.data.habilitadoAutenticacaoPessoaJuridica;

      this.urlCadastroPessoaFisica = response.data.urlCadastroPessoaFisica;
      this.urlCadastroPessoaJuridica = response.data.urlCadastroPessoaJuridica;

      this.isLoading = false;
    });
  },
};
</script>

<style></style>
